import {DEFAULT_IS_REFILL_ENABLED} from '../const';

export function createSettings(isRefillEnabled: boolean = DEFAULT_IS_REFILL_ENABLED): Settings {
  return {
    isRefillEnabled,
  };
}
